import HarIdxFrame from "../../components/HarIdxFrame";

export default function HomeValuePage() {
  return (
    <HarIdxFrame
      eyebrow="What's My Home Worth?"
      title="Instant Houston home valuation"
      description="Curious what your home is worth? Get a real-time estimate powered by HAR.com — then let's discuss a custom valuation over a cup of coffee."
      path="mls/homevalue/search"
      seoPath="/home-value"
    />
  );
}
